export default __webpack_public_path__ + "static/media/dashboard-web.166f9f62.png";